import "core-js/modules/es.number.constructor.js";
import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'BFooter',
  props: {
    color: {
      type: String,
      default: 'primaryText'
    },
    padding: {
      type: Number,
      default: 0
    },
    hasMaxWidth: {
      type: Boolean,
      default: true
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var whitelabelLite = useWhitelabelLite();
    var cookieConsent = useCookieConsent();
    var defaultPadding = computed(function () {
      if (props.padding !== 0) {
        return "padding: 14px ".concat(props.padding, "px");
      } else {
        return "padding: 14px 20px";
      }
    });
    function openCookieDialog() {
      cookieConsent.show(true);
    }
    function logomarkUrl() {
      var _whitelabelLite$logom;
      return (_whitelabelLite$logom = whitelabelLite === null || whitelabelLite === void 0 ? void 0 : whitelabelLite.logomarkUrl) !== null && _whitelabelLite$logom !== void 0 ? _whitelabelLite$logom : require('assets/img/logo_footer.svg');
    }
    return {
      __sfc: true,
      props: props,
      whitelabelLite: whitelabelLite,
      cookieConsent: cookieConsent,
      defaultPadding: defaultPadding,
      openCookieDialog: openCookieDialog,
      logomarkUrl: logomarkUrl
    };
  }
});